<template>
  <div>
    <h4>Change password</h4>

    <form @submit.prevent="changePassword">

      <b-form-group
        label="Your password (Old password of other user is not required.)"
        label-for="cur-password"
        :invalid-feedback="curPasswordInvalidFeedback"
        :state="curPasswordValidationState"
      >
        <password-input
          id="cur-password"
          ref="curPasswordInput"
          v-model="curPassword"
          :state="curPasswordValidationState"
          :maxlength="PASSWORD_MAX_LEN"
          autocomplete="off"
          required
          autofocus
        />
      </b-form-group>

      <div class="form-group">
        <label for="new-password">New password</label>
        <password-input
          id="new-password"
          v-model="newPassword"
          required
          :maxlength="PASSWORD_MAX_LEN"
          autocomplete="off"
        />
      </div>

      <b-form-group
        label="Confirm new password"
        label-for="new-password-copy"
        :invalid-feedback="newPasswordCopyInvalidFeedback"
        :state="newPasswordCopyValidationState"
      >
        <password-input
          id="new-password-copy"
          ref="newPasswordCopyInput"
          v-model="newPasswordCopy"
          required
          :maxlength="PASSWORD_MAX_LEN"
          :state="newPasswordCopyValidationState"
          autocomplete="off"
        />
      </b-form-group>

      <b-button :to="{name: 'user_info', params: {userId: userId}}">Cancel</b-button>
      <b-button type="submit" variant="primary">Change</b-button>
    </form>
 </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import PasswordInput from './PasswordInput.vue';

const PASSWORD_MAX_LEN = 100;

export default {
  name: 'UserChangePasswordOther',

  components: {
    PasswordInput,
  },

  props: {
    userId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      PASSWORD_MAX_LEN,

      curPassword: '',
      curPasswordValidationState: null,
      curPasswordInvalidFeedback: '',

      newPassword: '',

      newPasswordCopy: '',
      newPasswordCopyValidationState: null,
      newPasswordCopyInvalidFeedback: '',
    };
  },

  watch: {
    curPassword() {
      this.resetCurPasswordValidation();
    },

    newPassword() {
      this.resetNewPasswordCopyValidation();
    },

    newPasswordCopy() {
      this.resetNewPasswordCopyValidation();
    },
  },

  methods: {
    resetCurPasswordValidation() {
      this.curPasswordValidationState = null;
    },

    resetNewPasswordCopyValidation() {
      this.newPasswordCopyValidationState = null;
    },

    changePassword() {
      notifier.deleteSenderNotifications(this);

      this.resetCurPasswordValidation();
      this.resetNewPasswordCopyValidation();

      if(this.newPassword !== this.newPasswordCopy) {
        this.newPasswordCopyInvalidFeedback = "Passwords don't match.";
        this.newPasswordCopyValidationState = false;
        const newPasswordCopyInput = this.$refs.newPasswordCopyInput;
        if(newPasswordCopyInput !== null) {
          newPasswordCopyInput.focus();
        }
        return;
      }

      const data = new FormData();
      data.append('cur_password', this.curPassword);
      data.append('new_password', this.newPassword);

      const url = `/user/${this.userId}/change_other_user_password`;
      HTTP.post(url, data)
      .then(response => {
        const result = response.data.result.code;

        const RESULT_SUCCESS          = 1;
        const RESULT_NO_PERMISSION    = 2;
        const RESULT_INVALID_PASSOWRD = 3;

        if(result === RESULT_SUCCESS) {
          notifier.showSuccessAfterTransition('Password changed.');
          this.$router.push({name: 'user_info', params: {userId: this.userId}});
          return;
        }

        if(result === RESULT_NO_PERMISSION) {
          notifier.showError('No permission', {sender: this});
          return;
        }

        if(result === RESULT_INVALID_PASSOWRD) {
          this.curPasswordInvalidFeedback = 'Invalid current password.';
          this.curPasswordValidationState = false;
          const curPasswordInput = this.$refs.curPasswordInput;
          if(curPasswordInput !== null) {
            curPasswordInput.focus();
          }
          return;
        }

        notifier.showError(`Unknown result code ${result}.`, {sender: this});
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>
